// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 31/3/2023
 */

 .AddCoupon_headingContainer__3TCWq {
  display: flex;
  justify-content: space-between;
}

.AddCoupon_closeButton__wGbwI {
  padding: 0.2rem;
  border: 1px #47C2BB solid;
  color: #47C2BB;
}

.AddCoupon_formItem__tYYmn {
  margin-top: 1rem;
}

.AddCoupon_formLabel__TzPbW {
  font-weight: 600;
}

.AddCoupon_formInput__ettEG {
  margin-top: 0.3rem;
}

.AddCoupon_validation__fNoXz {
  color: red;
}

.AddCoupon_buttonContainer__3zfuO {
  margin-top: 2rem;
  margin-bottom: 1rem;
  display: flex;
  justify-content: center;
}

.AddCoupon_submitButton__HOvn0 {
  width: 10rem;
}`, "",{"version":3,"sources":["webpack://./src/Components/Coupon/AddCoupon.module.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;;;;;;;;;EAoBE;;CAED;EACC,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,YAAY;AACd","sourcesContent":["/*\r\n * Copyright (c) 2023 by N-Ach (Pvt) Ltd\r\n *\r\n * ╔═╗ ╔╗    ╔═══╗  ╔╗\r\n * ║║╚╗║║    ║╔═╗║  ║║\r\n * ║╔╗╚╝║    ║║ ║╠══╣╚═╗\r\n * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║\r\n * ║║ ║║║╚══╝║╔═╗║╚═╣║║║\r\n * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝\r\n *\r\n * All rights reserved.\r\n *\r\n * This software is the confidential and proprietary information\r\n * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential\r\n * Information and shall use it only in accordance with the terms\r\n * of the license agreement you entered into with N-Ach (Pvt) Ltd.\r\n *\r\n *\r\n * @Author Dilhari Jayathunga\r\n * @Date 31/3/2023\r\n */\r\n\r\n .headingContainer {\r\n  display: flex;\r\n  justify-content: space-between;\r\n}\r\n\r\n.closeButton {\r\n  padding: 0.2rem;\r\n  border: 1px #47C2BB solid;\r\n  color: #47C2BB;\r\n}\r\n\r\n.formItem {\r\n  margin-top: 1rem;\r\n}\r\n\r\n.formLabel {\r\n  font-weight: 600;\r\n}\r\n\r\n.formInput {\r\n  margin-top: 0.3rem;\r\n}\r\n\r\n.validation {\r\n  color: red;\r\n}\r\n\r\n.buttonContainer {\r\n  margin-top: 2rem;\r\n  margin-bottom: 1rem;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n\r\n.submitButton {\r\n  width: 10rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"headingContainer": `AddCoupon_headingContainer__3TCWq`,
	"closeButton": `AddCoupon_closeButton__wGbwI`,
	"formItem": `AddCoupon_formItem__tYYmn`,
	"formLabel": `AddCoupon_formLabel__TzPbW`,
	"formInput": `AddCoupon_formInput__ettEG`,
	"validation": `AddCoupon_validation__fNoXz`,
	"buttonContainer": `AddCoupon_buttonContainer__3zfuO`,
	"submitButton": `AddCoupon_submitButton__HOvn0`
};
export default ___CSS_LOADER_EXPORT___;
